















































































































import { defineComponent, PropType } from '@vue/composition-api';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import HelpTooltip from '@front-app/components/dropdowns/HelpTooltip.vue';
import HelpTooltipBlock from '@front-app/components/dropdowns/HelpTooltipBlock.vue';
import RadioButton from '@front-app/components/inputs/RadioButton.vue';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import SuccessCard from '@front-app/components/cards/state/SuccessCard.vue';
import TrForm from '@front-app/components/form/Form.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { GroupWithCommunity } from '@front-app/services/GroupsApi/GroupModel';
import { Size, Spacing } from '@front-app/components/constants';
import { syncedRef } from '@front-app/util/reactivity';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { useGroupVisibilityStore } from '@front-app/store/piniaModules/groupVisibility';
import { VisibilityOption } from '@front-app/services/GroupsApi/GroupEvent';

export default defineComponent({
	components: {
		CtaButton,
		ErrorCard,
		HelpTooltip,
		HelpTooltipBlock,
		RadioButton,
		SimpleCard,
		SuccessCard,
		TrForm,
	},
	props: {
		group: {
			type: Object as PropType<GroupWithCommunity>,
			required: true,
		},
	},
	setup(props) {
		const selectedVisibility = syncedRef(() => props.group.visibilitySettings.visibility).ref;
		const isSelectedVisibility = (target: VisibilityOption): boolean => target === selectedVisibility.value;

		const {
			track,
			isError,
			isLoading,
			isSuccess,
		} = useAsyncStatus();
		const setVisibility = () => {
			track(useGroupVisibilityStore().updateSettings(props.group.id, {
				visibility: selectedVisibility.value,
			}));
		};

		return {
			VisibilityOption,
			selectedVisibility,
			isSelectedVisibility,
			// Submission
			setVisibility,
			isError,
			isLoading,
			isSuccess,
			// Util
			ButtonPalettes,
			Size,
			Spacing,
		};
	},
});
